module.exports = __webpack_public_path__ + "static/img/skirmisher3.fdd3434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/skirmisher3.png
// module id = OiVS
// module chunks = 0